import React, { PureComponent } from 'react'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import { connect } from 'react-redux'
import { APP_URL } from '../../utils/config.js'
import {
  addToCart,
  getFabricById,
  setCanProceedToNextStep,
  setCordFabricDirection,
  setFabricDirection,
  setSelectedCordFabric,
  setSelectedFabric,
  setSingleCordFabric,
  setSingleFabric,
} from '../../actions/generalActions.js'
import _ from 'lodash'
import { PulseLoader } from 'react-spinners'
import { addCanonical, getEstimate, scrollTo, sendGtag } from '../../utils/utils.js'
import { formatPrice } from '../../utils/format.js'
import { ReactComponent as BarCode } from '../../../assets/icons/bar-code.svg'
import { ReactComponent as Box } from '../../../assets/icons/box.svg'
import { ReactComponent as Price } from '../../../assets/icons/price.svg'
import { ReactComponent as Swatch } from '../../../assets/icons/swatch.svg'
import { ReactComponent as Material } from '../../../assets/icons/material.svg'
import { ReactComponent as Drop } from '../../../assets/icons/drop.svg'
import { ReactComponent as Medal } from '../../../assets/icons/medal.svg'
import { ReactComponent as Pattern } from '../../../assets/icons/pattern.svg'
import { ReactComponent as IndoorOutdoor } from '../../../assets/icons/indoor-outdoor.svg'
import { ReactComponent as Bath } from '../../../assets/icons/bath.svg'
import { ReactComponent as Arrow } from '../../../assets/icons/arrow.svg'
import Button from '../Templates/RedesignButton.js'
import HorizontalStripes from '../../../assets/images/horizontal-stripes.webp'
import VerticalStripes from '../../../assets/images/vertical-stripes.webp'

class SingleFabric extends PureComponent {
  constructor(props) {
    super(props)

    const { general, fabrics, params } = props
    const { singleFabric: singleFabricId, singleCordFabric: singleCordFabricId } = general
    const fabricID = params.style ? singleCordFabricId : singleFabricId

    let singleFabric

    if (params.style) {
      singleFabric =
        fabrics.filteredCordingFabrics.find((fabric) => fabric.id === singleCordFabricId) ||
        fabrics.filteredFabrics.find((fabric) => fabric.id === singleCordFabricId)
    } else {
      singleFabric = fabrics.filteredFabrics.find(
        (fabric) => fabric.id === (params.style ? singleCordFabricId : singleFabricId),
      )
    }

    this.state = {
      isMobile: false,
      isFavourite: !!(JSON.parse(localStorage.getItem('favourites')) || []).find(
        (fabricId) => fabricId === (params.style ? singleCordFabricId : singleFabricId),
      ),
      singleFabric: singleFabric || { id: null },
      isDirectional:
        singleFabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'is directional')
          ?.options[0] === 'yes',
      fabricID: fabricID || null,
    }
  }

  componentDidMount() {
    const { history } = this.props
    const { fabricID, singleFabric } = this.state

    this._checkForMobileLayout()
    window.addEventListener('resize', this._checkForMobileLayout)
    setTimeout(() => {
      this._getPrice()
    }, 700)

    if (singleFabric.id === null) {
      let fabric = fabricID
      if (fabricID === null) {
        fabric = history.location.search.split('=')[1]
      }
      getFabricById(fabric).then((res) => {
        this.setState({
          singleFabric: res,
          isDirectional:
            res?.attributes?.find((attr) => attr.name.toLowerCase() === 'is directional')
              ?.options[0] === 'yes',
        })
      })
    }
    this.setState({ isMobile: window.innerWidth <= 991 }, () => {
      this._scrollToDirectionIfIsDirectional()
    })

    sendGtag('view_item', null, {
      items: [
        {
          item_id: singleFabric?.sku ? singleFabric?.sku : `#${singleFabric?.id.toString()}`,
          item_name: singleFabric?.name,
        }
      ],
    })

    this._toggleCushionFabric(singleFabric)()
  }

  componentWillUnmount() {
    const { dispatch, params } = this.props
    if (params.style) {
      dispatch(setSingleCordFabric(null))
    } else {
      dispatch(setSingleFabric(null))
    }
    window.removeEventListener('resize', this._checkForMobileLayout)
  }

  componentDidUpdate(prevProps, prevState) {
    const { singleFabric, isMobile } = this.state
    const { location, history, switchCurrentView, general, params } = this.props
    const { general: prevGeneral, params: prevParams } = prevProps
    const { fabric: mainFabric, cordFabric } = general
    const { fabric: prevMainFabric, cordFabric: prevCordFabric } = prevGeneral
    const fabric = params.style ? cordFabric : mainFabric
    const prevFabric = prevParams.style ? prevCordFabric : prevMainFabric

    if (location !== prevProps.location && history.location.search === '') {
      switchCurrentView()
    }

    if (!prevState.singleFabric?.permalink && singleFabric?.permalink) {
      addCanonical(singleFabric.permalink)
    }

    if (
      singleFabric.id !== prevState.singleFabric.id ||
      fabric?.id !== prevFabric?.id ||
      isMobile !== prevState.isMobile
    ) {
      this._scrollToDirectionIfIsDirectional()
    }
  }

  _scrollToDirectionIfIsDirectional = () => {
    const { params, general } = this.props
    const { singleFabric, isMobile } = this.state
    const { fabric: mainFabric, cordFabric } = general

    const fabric = params.style ? cordFabric : mainFabric
    const isDirectional =
      singleFabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'is directional')
        ?.options[0] === 'yes'

    if (singleFabric.id === fabric?.id && isDirectional && !params.style && isMobile) {
      scrollTo('cushion-fabric-direction-container', 500, 50, -125)
    }
  }

  _checkForMobileLayout = _.debounce(() => {
    this.setState({ isMobile: window.innerWidth <= 991 })
  }, 100)

  // once this function runs, the selectedValue field in redux will be populated
  // and we should allow users to click the next button to navigate
  // to the next step
  _toggleCushionFabric = (cushion) => () => {
    const { singleFabric, isDirectional } = this.state
    const { dispatch, general, params, isStyle } = this.props
    const { fabric, cordFabric, fabricDirection } = general
    const isFabricSelected = fabric && singleFabric.id === fabric?.id
    const isCordFabricSelected = cordFabric && singleFabric.id === fabric?.id

    if (isStyle) {
      if (general?.fabric?.id !== cushion?.id) {
        sendGtag('select_fabric_type_style', cushion?.name)
      }
    }
    else {
      if (general?.fabric?.id !== cushion?.id) {
        sendGtag('select_fabric_type_fabrics', cushion?.name)
      }
    }

    if (!params.style && isFabricSelected) {
      return
    }

    const canProceed = params.style
      ? !isCordFabricSelected
      : !isFabricSelected &&
        (!isDirectional || (!!fabricDirection && fabricDirection !== 'nondirectional'))

    if (params.style) {
      dispatch(setSelectedCordFabric(cushion, canProceed))
      if (!isDirectional) {
        dispatch(setCordFabricDirection('nondirectional'))
      }
    } else {
      dispatch(setSelectedFabric(cushion, canProceed))
      dispatch(setSelectedCordFabric(cushion, null))
      if (!isDirectional) {
        dispatch(setCordFabricDirection('nondirectional'))
        dispatch(setFabricDirection('nondirectional'))
      }
    }

    if (
      fabric?.attributes?.find((attr) => attr.name === 'dimension') ||
      cordFabric?.attributes?.find((attr) => attr.name === 'dimension')
    ) {
      dispatch(params.style ? setCordFabricDirection(null) : setFabricDirection(null))
      if (params.style) {
        dispatch(setCanProceedToNextStep(true))
      } else {
        dispatch(setCanProceedToNextStep(false))
      }
    }
    setTimeout(() => {
      this._getPrice()
    }, 500)
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    getEstimate(dispatch, general, params)()
  }

  _selectFabricDirection = (direction) => () => {
    const { dispatch, params, general } = this.props

    if (general?.cordFabricDirection !== direction) {
      sendGtag('select_fabric_direction_fabrics', `${general?.type?.name}_Fabric Direction ${direction}`)
    }

    dispatch(params.style ? setCordFabricDirection(direction) : setFabricDirection(direction))
    if (params.style) {
      dispatch(setCordFabricDirection(direction))
    } else {
      dispatch(setCordFabricDirection(direction))
      dispatch(setFabricDirection(direction))
    }

    dispatch(setCanProceedToNextStep(true))

    setTimeout(() => {
      this._getPrice()
    }, 500)
  }

  _getInfo = () => {
    const { singleFabric } = this.state
    const { fabrics } = this.props
    const { brands } = fabrics
    const info = {}

    singleFabric.attributes?.forEach((attribute) => {
      const key = attribute?.name
        ?.split(' ')
        .map((word) => word.toLowerCase())
        .join('_')
      info[key] = attribute?.options.join(', ')
    })
    info['sku'] = singleFabric.sku || '-'
    info['item_number'] = singleFabric.id
    info['price'] = parseFloat(singleFabric.regular_price).toFixed(2).toString() || '-'
    info['name'] = singleFabric.name
    info['cleaning'] =
      Object.values(brands).find((brand) => brand.name.toLowerCase() === info?.brand?.toLowerCase())
        ?.fabricsCare || '-'

    return info
  }

  addToCartCallback = () => {
    if (window?.increment_cart) {
      window.increment_cart()
    }
  }

  _buySwatch = () => {
    const { singleFabric } = this.state
    const { dispatch, fabrics, general, params, isStyle } = this.props
    const { singleFabric: singleFabricId, singleCordFabric: singleCordFabricId } = general
    const { filteredFabrics, filteredCordingFabrics } = fabrics

    let cartKey = localStorage.getItem('cartKey')

    let foundFabric

    if (params.style) {
      foundFabric = filteredCordingFabrics?.find(
        (fabric) => fabric.id.toString() === singleCordFabricId?.toString(),
      )
    } else {
      foundFabric = filteredFabrics?.find(
        (fabric) => fabric.id.toString() === singleFabricId?.toString(),
      )
    }

    const fabricSku = foundFabric?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal sku',
    )?.options[0]
    const fabricColor = foundFabric?.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    const fabricBrand = foundFabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'brand')
      ?.options[0]

    const fabric = {
      type: 'fabric',
      pa_swatch: true,
      is_swatch: true,
      product_name: singleFabric?.slug,
      pa_internal_sku: fabricSku,
      pa_attribute_brand: fabricBrand,
      pa_internal_color_number: fabricColor,
    }

    if (params.style) {
      fabric.pa_cording_sku = singleFabric?.sku
      fabric.pa_cording_fabric_material =
        foundFabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'material')
          ?.options[0] || ''
    } else {
      fabric.pa_sku = singleFabric?.sku
      fabric.pa_fabric_material =
        foundFabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'material')
          ?.options[0] || ''
    }

    if (isStyle) {
      sendGtag('buy_swatch_style', singleFabric?.name)
    }
    else {
      sendGtag('buy_swatch_fabrics', singleFabric?.name)
    }

    const info = Object.keys(fabric).length > 0 ? this._getInfo() : null

    sendGtag('add_to_cart', null, {
      currency: 'USD',
      value: parseFloat(formatPrice(info?.price_per_swatch).replace('$', '')),
      items: [
        {
          item_id: singleFabric?.sku,
          item_name: singleFabric?.name,
        },
      ],
    })

    dispatch(addToCart(cartKey, singleFabric, fabric, true, false, this.addToCartCallback))
  }

  _switchBack = (e) => {
    const { history } = this.props
    const currentUrl = history.location.pathname
    const url = e ? currentUrl.split('?')[0] : currentUrl.split('?')[0] + '?fabric_next=true'
    history.replace({ pathname: url, search: '', state: { isActive: true } })
  }

  _switchNext = () => {
    this._switchBack( false )
  }

  _toggleFavouriteFabric = (fabricId, fabricName) => () => {
    const { isStyle } = this.props
    const currentFavourites = JSON.parse(localStorage.getItem('favourites')) || []
    if (currentFavourites.includes(fabricId)) {
      const newFavourites = currentFavourites.filter((id) => id !== fabricId)
      localStorage.setItem('favourites', JSON.stringify(newFavourites))
      this.setState({ isFavourite: false })

      if (isStyle) {
        sendGtag('favorites_style', `${fabricName}_Favorite value 0`)
      }
      else {
        sendGtag('favorites_fabrics', `${fabricName}_Favorite value 0`)
      }
    } else {
      localStorage.setItem('favourites', JSON.stringify([...currentFavourites, fabricId]))
      this.setState({ isFavourite: true })

      if (isStyle) {
        sendGtag('favorites_style', `${fabricName}_Favorite value 1`)
      }
      else {
        sendGtag('favorites_fabrics', `${fabricName}_Favorite value 1`)
      }
    }
  }

  selectFabric = () => {
    const { singleFabric, isDirectional } = this.state
    const { general, params, isStyle } = this.props
    const { fabric: mainFabric, cordFabric } = general
    const fabric = params.style ? cordFabric : mainFabric

    this._toggleCushionFabric(singleFabric)()

    if ((singleFabric.id === fabric?.id && isDirectional && !params.style) || !isDirectional || params.style) {
      this._switchNext()
    }
  }

  render() {
    const { singleFabric, isFavourite, isDirectional } = this.state
    const { general, params, subtitle } = this.props
    const {
      fabric: mainFabric,
      cordFabric,
      fabricDirection,
      cordFabricDirection,
      addingToCart,
      style,
    } = general

    const fabric = params.style ? cordFabric : mainFabric
    const direction = params.style ? cordFabricDirection : fabricDirection

    const info = this._getInfo()

    let splitPathName = location.pathname.split('/')

    if (style) {
      splitPathName[splitPathName.length - 1] =
        `${style.id}-${general['fabric']?.id}${general.fabricDirection ? `-${general.fabricDirection}` : '-nondirectional'}-${general.fabric?.name?.split(' ').join('-').toLowerCase()}`
    } else {
      splitPathName[splitPathName.length - 1] =
        `${general['fabric']?.id}${general.fabricDirection ? `-${general.fabricDirection}` : '-nondirectional'}-${general.fabric?.name?.split(' ').join('-').toLowerCase()}`
    }

    return (
      <div>
        <div className="single-fabric-header-wrapper">
          <div className="header-name-wrapper">
            <button
              id="back-to-results"
              className={'single-fabric-back-button'}
              type={'button'}
              onClick={this._switchBack}
            >
              <Arrow height={12} width={8} viewBox="0 0 8 12" /> All Fabrics
            </button>
          </div>
          <div className="header-action-wrapper">
            <button
              className="favorite-button"
              type="button"
              onClick={this._toggleFavouriteFabric(singleFabric.id, singleFabric.name)}
            >
              <img
                id="favorite-img"
                className={`favourite-button ${isFavourite ? 'favourite-button-visible' : ''}`}
                src={`${APP_URL}/wp-content/uploads/2021/11/${isFavourite ? 'heart-full' : 'heart'}.svg`}
              />
            </button>
            <Button
              id="add-swatch"
              onClick={this._buySwatch}
              className={'single-fabric-buy-swatch-button'}
              variant="primary"
            >
              {addingToCart ? <PulseLoader color={'#FFFFFF'} size={8} /> : 'Buy Swatch'}
            </Button>
            <Button
              id="next-step-link"
              className="redesign-button button-base"
              onClick={this.selectFabric}
              disabled={isDirectional && singleFabric.id === fabric?.id && (!cordFabricDirection || cordFabricDirection === 'nondirectional')}
            >
              Next
            </Button>
          </div>
        </div>
        <div className="single-fabric-header-wrapper">
          <div className="header-name-wrapper">
            <div className="header-title">{info.name}</div>
          </div>
        </div>
        {!!subtitle && subtitle}
        {singleFabric.id !== null && (
          <div className={'single-fabric-container'}>
            <div className={'single-fabric-preview'}>
              <div
                id="select-this-fabric"
                onClick={this._toggleCushionFabric(singleFabric)}
                className={`single-fabric-select-button ${singleFabric.id === fabric?.id ? 'disabled' : ''}`}
              >
                <div>
                  {singleFabric.id === fabric?.id && (
                    <img
                      className="fabric-img"
                      src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`}
                    />
                  )}
                </div>
              </div>
              <div className="single-fabric-wrapper">
                <img src={singleFabric?.images[0]?.src} />
              </div>
              <div className={'single-fabric-image-disclaimer'}>
                <p>
                  Each fabric image represents it&apos;s respective color, however due to monitor
                  resolution, browser rendering, etc. Cushion Pros highly recommends ordering
                  swatches first. You can do this{' '}
                  <a href={`${APP_URL}/fabrics`}>
                    <u>here</u>
                  </a>
                  .
                </p>
                <p>
                  Cushion Pros does not endorse machine washing of any fabric offered on our site;
                  we recommend spot clean only.
                </p>
              </div>
            </div>
            <div className="mobile-header-action-wrapper">
              <button
                className="favorite-button"
                type="button"
                onClick={this._toggleFavouriteFabric(singleFabric.id, singleFabric.name)}
              >
                <img
                  id="favorite-img"
                  className={`favourite-button ${isFavourite ? 'favourite-button-visible' : ''}`}
                  src={`${APP_URL}/wp-content/uploads/2021/11/${isFavourite ? 'heart-full' : 'heart'}.svg`}
                />
              </button>
              <Button
                id="add-swatch"
                onClick={this._buySwatch}
                className={'single-fabric-buy-swatch-button'}
                variant="primary"
              >
                {addingToCart ? <PulseLoader color={'#FFFFFF'} size={8} /> : 'Buy Swatch'}
              </Button>
              <Button
                id="next-step-link"
                className="redesign-button button-base"
                onClick={this.selectFabric}
                disabled={isDirectional && singleFabric.id === fabric?.id && (!cordFabricDirection || cordFabricDirection === 'nondirectional')}
              >
                Next
              </Button>
            </div>
            <div className={'cushion-fabric-details-container'}>
              {singleFabric.id === fabric?.id && isDirectional && !params.style ? (
                <div className={'cushion-fabric-direction-container'}>
                  <p>
                    You have chosen a directional fabric. Please let us know how you would like the
                    pattern to run by selecting one of the images below.
                  </p>
                  <div className={'cushion-fabric-direction-grid'}>
                    <div
                      id="fabric-direction-horizontal"
                      onClick={this._selectFabricDirection('horizontal')}
                      className={`cushion-fabric-direction-selector-card ${direction === 'horizontal' ? 'active' : ''}`}
                    >
                      <div className={'cushion-fabric-direction-selector-card-checkbox'}>
                        {direction === 'horizontal' && (
                          <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
                        )}
                      </div>
                      <img src={HorizontalStripes} />
                      <h3>Horizontal (Side-to-Side, Left-to-Right)</h3>
                    </div>
                    <div
                      id="fabric-direction-vertical"
                      onClick={this._selectFabricDirection('vertical')}
                      className={`cushion-fabric-direction-selector-card ${direction === 'vertical' ? 'active' : ''}`}
                    >
                      <div className={'cushion-fabric-direction-selector-card-checkbox'}>
                        {direction === 'vertical' && (
                          <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
                        )}
                      </div>
                      <img src={VerticalStripes} />
                      <h3>Vertical (Top-to-Bottom, Front-to-Back)</h3>
                    </div>
                  </div>
                </div>
              ) : ''}
              <div className={'single-fabric-details'}>
                <table>
                  <tr>
                    <td>
                      <BarCode />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">SKU Number:</span>
                      <span className="single-fabric-details-value">{info.sku}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Box />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Item Number:</span>
                      <span className="single-fabric-details-value">{info.item_number}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Price />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Price/yard:</span>
                      <span className="single-fabric-details-value">${info.price}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Swatch />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Swatch:</span>
                      <span className="single-fabric-details-value">
                        {formatPrice(info.price_per_swatch)}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Material />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Material:</span>
                      <span className="single-fabric-details-value">
                        {info.material?.replace(/&amp;/g, '&')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Drop />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Color:</span>
                      <span className="single-fabric-details-value">
                        {info.color?.replace(/&amp;/g, '&')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Medal />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Brand:</span>
                      <span className="single-fabric-details-value">
                        {info.brand?.replace(/&amp;/g, '&')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Pattern />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Pattern:</span>
                      <span className="single-fabric-details-value">
                        {info.pattern?.replace(/&amp;/g, '&')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <IndoorOutdoor />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Use:</span>
                      <span className="single-fabric-details-value">
                        {info.use?.replace(/&amp;/g, '&')}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Bath />
                    </td>
                    <td>
                      <span className="single-fabric-details-label">Cleaning:</span>
                      <span className="single-fabric-details-value">
                        {info.cleaning?.replace(/&amp;/g, '&')}
                      </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="mobile-single-fabric-image-disclaimer">
              <p>
                Each fabric image represents it&apos;s respective color, however due to monitor
                resolution, browser rendering, etc. Cushion Pros highly recommends ordering swatches
                first. You can do this{' '}
                <a href={`${APP_URL}/fabrics`}>
                  <u>here</u>
                </a>
                .
              </p>
              <p>
                Cushion Pros does not endorse machine washing of any fabric offered on our site; we
                recommend spot clean only.
              </p>
            </div>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default connect(mapStateToProps)(withRoutingTracker(SingleFabric))
